import React from 'react'
import Typography from '@material-ui/core/Typography'
import BackButton from '../Common/BackButton'

const Headline = ({
    hasCustomSlug,
    baseConfig,
    isVirtual,
    cardNetwork,
    classes,
    baseUrl,
}) => {
    const getHeadlineContent = () => {
        if (hasCustomSlug) {
            return baseConfig.h1
        }

        if (isVirtual) {
            return (
                <span>
                    <span style={{ color: '#3E065F' }}>Personalize </span>
                    Your <br />
                    Digital {cardNetwork?.name}
                    <span className={classes.registeredTrademark}>® </span>
                    Gift Card!
                </span>
            )
        }

        return (
            <span>
                Build Your Perfect <br />
                <span style={{ color: '#3E065F' }}>{cardNetwork?.name}</span>
                <span className={classes.registeredTrademark}>® </span>
                Gift Card!
            </span>
        )
    }

    return (
        <div style={{ width: '100%' }}>
            <BackButton
                tabIndex={0}
                backAction={() => {
                    window.location.href = baseUrl
                }}
                ariaText={'Go back to homepage'}
                buttonText={'Back'}
                className={classes.backButtonWrapper}
            />
            <Typography
                variant="h1"
                className={classes.h1}
                style={{ marginTop: 0 }}
            >
                {getHeadlineContent()}
            </Typography>
        </div>
    )
}

export default Headline
